import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  RoleHelperService,
  RoleOperatorActions,
} from '@app/core/services/role-helper.service';
import { RadioState } from '@app/core/states/radio.state';
import { baseNav } from '@app/shared/modules/navigation/navigation.model';
import { ModelNav } from '@app/shared/modules/navigation/navigation.service';
import { Select } from '@ngxs/store';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { defaultIfEmpty, filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'rk-redirector',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectionComponent implements OnInit, OnDestroy {
  @Select(RadioState.currentRadioId)
  currentRadioId$: Observable<number>;

  subscription = new Subscription();

  observables$: Observable<string>[] = [];

  interval: any;
  constructor(
    private readonly _roleService: RoleHelperService,
    private readonly _router: Router,
  ) {}

  ngOnInit() {
    this.interval = setInterval(() => {
      this.findPath();
    }, 500);
  }

  findPath() {
    baseNav.map(item => {
      if (item.url) {
        // If parent, then create observable
        this.observables$.push(this.observableFromModelNav(item));
      } else if (item.children && item.id !== 'admin') {
        item.children.map(subItem => {
          // It should be parent
          subItem.roles = subItem.roles || item.roles; // Inherit parent roles if don't have any
          this.observables$.push(this.observableFromModelNav(subItem));
        });
      }
    });

    let idradio: number;

    const combinedStream$ = this.currentRadioId$.pipe(
      filter(id => !!id),
      mergeMap(id => {
        idradio = id;

        return combineLatest(this.observables$);
      }),
    );

    let pathfound = false;

    this.subscription.add(
      combinedStream$.subscribe(paths => {
        while (!pathfound && paths.length > 0) {
          if (paths[0] === '') {
            paths.shift();
          } else {
            pathfound = true;
            this._router.navigateByUrl('/radio/' + idradio + paths[0]);
          }
        }
      }),
    );
  }

  observableFromModelNav(item: ModelNav): Observable<string> {
    if (item.roles['type']) {
      return this._roleService
        .hasRole({
          type: item.roles['type'],
          roleIds: item.roles['roleIds'],
        })
        .pipe(
          map(res => (res ? item.url : '')),
          defaultIfEmpty(''),
        );
    }

    return this._roleService
      .hasRole({
        type: RoleOperatorActions.SPECIFIC,
        roleId: item.roles.toString(),
      })
      .pipe(
        map(res => (res ? item.url : '')),
        defaultIfEmpty(''),
      );
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this.subscription.unsubscribe();
  }
}
